import { screenshotSystem } from '@naker/services/System/screenshotSystem';

import { Vector3 } from '@babylonjs/core/Maths/math';
import { ArcRotateCamera } from '@babylonjs/core/Cameras/arcRotateCamera';
import { setStyle } from 'redom';

export class editorSystem extends screenshotSystem {

    camera: ArcRotateCamera;

    constructor(canvas: HTMLCanvasElement) {
        super(canvas);

        setStyle(this.canvas, { 'pointer-events': 'none' });

        this.camera = new ArcRotateCamera('main_camera', Math.PI / 2, Math.PI / 2, 10, new Vector3(0, 0, 0), this.scene);
        this.camera.setTarget(new Vector3(0, 0, 0));
        this.camera.minZ = 0;

        // Do not optimize system here or won't be able to make correct screenshot 
        // this.optimize();
        // this.scene.blockMaterialDirtyMechanism = true;
    }
}